/**
 * Central source of truth for legal document versions.
 *
 * When you update the Privacy Policy or Terms of Service:
 * 1. Bump the version string here.
 * 2. Add a new Supabase migration that:
 *    a) Inserts the new version into legal_document_versions with the
 *       full plain-text content so it is preserved for legal audit:
 *
 *       INSERT INTO public.legal_document_versions
 *         (document_type, version, effective_date, content_text)
 *       VALUES ('terms', '2.0', '2026-XX-XX', $$...full text...$$);
 *
 *    b) Does NOT delete old rows — old accepted versions must remain
 *       readable for legal disputes.
 * 3. Update the `lastUpdated` prop in TermsPage / PrivacyPage accordingly.
 *
 * On next login, users who haven't accepted the new version will see the
 * consent modal. Their acceptance is stored in user_legal_consents together
 * with IP address and User-Agent for forensic traceability.
 */
export const LEGAL_VERSIONS = {
  terms:   '2.0',
  privacy: '2.0',
} as const;

export type DocumentType = keyof typeof LEGAL_VERSIONS;
